import React from "react";

interface AudioPlayerProps {
  trackUrl: string;
  color?: string;
  height?: number;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ trackUrl, color = "#8B4513", height = 200 }) => {
  const encodedUrl = encodeURIComponent(trackUrl);

  return (
    <div className="w-full bg-gray-50 rounded-xl shadow-md overflow-hidden border">
      <iframe
        width="100%"
        height={height}
        scrolling="no"
        frameBorder="no"
        allow="autoplay"
        className="rounded-t-xl flex flex-col"
        title="SoundCloud Audio Player"
        src={`https://w.soundcloud.com/player/?url=${encodedUrl}&color=${encodeURIComponent(
          color
        )}&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=false`}
      ></iframe>
    </div>
  );
};

export default AudioPlayer;
